import ApiService from '@/services/api.service'


const CalendarResTimeAllocations = {
    getAll(parameter){
        const params = {
            PageNumber         : parameter.PageNumber,
            PageSize           : parameter.PageSize,
            DateFrom           : parameter.DateFrom,
            DateTo             : parameter.DateTo,
            SearchCriteria     : parameter.SearchCriteria,
            EmployeeCodeList   : parameter.EmployeeCodeList,
            AppointmentTypeList: parameter.AppointmentTypeList,
            Status             : parameter.Status
        }
        return ApiService.getWithArray('/CalendarResTimeAllocations/blockingtimes',params);
    },

  Add(data){
    return ApiService.post(`/CalendarResTimeAllocations`, data);
  },
  Delete(Id){
    return ApiService.delete(`/CalendarResTimeAllocations/${Id}`);
  },
  Update(Id,data){
    return ApiService.put(`/CalendarResTimeAllocations/${Id}`,data);
  },
  Get(Id){
    return ApiService.get(`/CalendarResTimeAllocations/${Id}`);
  },

}

  export default CalendarResTimeAllocations;
